import React from 'react';
import {useSWRConfig} from 'swr';
import {useVoting} from '../providers/voting';
import {GET_TALKING_POINTS_QUERY_KEY} from '../config/misc';

const useResetVotes = () => {
  const {mutate} = useSWRConfig();
  const {resetVotes} = useVoting();

  const resetVoteHandler = React.useCallback(async () => {
    await resetVotes();
    mutate(GET_TALKING_POINTS_QUERY_KEY);
  }, [mutate, resetVotes]);

  return resetVoteHandler;
};

export default useResetVotes;
